import {Style, Stroke} from 'ol/style';

import {useVectorLayer, useVectorSource} from './OpenLayers/hooks';

const LayerStyle = new Style({
    stroke: new Stroke({
        color: 'green',
        width: 10,
    }),
});

const useFAITriangle = zIndex => {
    const source = useVectorSource({}, []);

    useVectorLayer({source, style: LayerStyle, zIndex}, [source]);

    return source;
};

export default useFAITriangle;
